export const API_URL = process.env.REACT_APP_API_URL as string
export const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY as string
export const SERVER_PUBLIC_KEY = process.env.REACT_APP_SERVER_PUBLIC_KEY as string
